var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupTypes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83334 4.99999C5.83334 4.53975 6.20643 4.16666 6.66667 4.16666H17.5C17.9602 4.16666 18.3333 4.53975 18.3333 4.99999C18.3333 5.46023 17.9602 5.83332 17.5 5.83332H6.66667C6.20643 5.83332 5.83334 5.46023 5.83334 4.99999Z",
    fill: "#D4C8FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83334 9.99999C5.83334 9.53975 6.20643 9.16666 6.66667 9.16666H17.5C17.9602 9.16666 18.3333 9.53975 18.3333 9.99999C18.3333 10.4602 17.9602 10.8333 17.5 10.8333H6.66667C6.20643 10.8333 5.83334 10.4602 5.83334 9.99999Z",
    fill: "#D4C8FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83334 15C5.83334 14.5398 6.20643 14.1667 6.66667 14.1667H17.5C17.9602 14.1667 18.3333 14.5398 18.3333 15C18.3333 15.4602 17.9602 15.8333 17.5 15.8333H6.66667C6.20643 15.8333 5.83334 15.4602 5.83334 15Z",
    fill: "#D4C8FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66666 4.99999C1.66666 4.53975 2.03976 4.16666 2.5 4.16666H2.50833C2.96857 4.16666 3.34166 4.53975 3.34166 4.99999C3.34166 5.46023 2.96857 5.83332 2.50833 5.83332H2.5C2.03976 5.83332 1.66666 5.46023 1.66666 4.99999Z",
    fill: "#D4C8FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66666 9.99999C1.66666 9.53975 2.03976 9.16666 2.5 9.16666H2.50833C2.96857 9.16666 3.34166 9.53975 3.34166 9.99999C3.34166 10.4602 2.96857 10.8333 2.50833 10.8333H2.5C2.03976 10.8333 1.66666 10.4602 1.66666 9.99999Z",
    fill: "#D4C8FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66666 15C1.66666 14.5398 2.03976 14.1667 2.5 14.1667H2.50833C2.96857 14.1667 3.34166 14.5398 3.34166 15C3.34166 15.4602 2.96857 15.8333 2.50833 15.8333H2.5C2.03976 15.8333 1.66666 15.4602 1.66666 15Z",
    fill: "#D4C8FA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupTypes);
export default __webpack_public_path__ + "static/media/groupTypes.ca6d995a.svg";
export { ForwardRef as ReactComponent };